module.exports = __webpack_public_path__ + "static/img/tese-img5.62f0bb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/tese-img5.png
// module id = 935
// module chunks = 0